import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { ActivityPrice } from '../types/entities/ActivityPrice';
import { promotions } from './promotions';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { CustomFieldForActivityPrices } from '../components/Table/fields/CustomFieldForActivityPrices';
import {CustomFieldForActivityCommissions} from "../components/Table/fields/CustomFieldForActivityCommissions";

export const activityWebsitePrice: SchemaWithClient<any> = {
  name: 'Activity Website Price',
  pluralName: 'Activity Website Price',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      readOnly: true,
    },
    sales_partner: {
      name: 'Sales Partner',
      fieldRenderer: SelectField.tableAdapter(enumItems.salesPartner),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.salesPartner
      ),
      multiSwitchboard: true,
      url: enumItems.salesPartner.client.getAllPath,
      tempSchema: enumItems.salesPartner,
      readOnly: true,
      hide: true,
    },
    activity: {
      name: 'Activity',
      fieldRenderer: SelectField.tableAdapter(enumItems.activity),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.activity),
      switchboard: true,
      url: enumItems.activity.client.getAllPath,
      tempSchema: enumItems.activity,
      /*readOnly: true,*/
    },
    valid_from: {
      name: 'Valid From',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    valid_to: {
      name: 'Valid to',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    booking_from: {
      name: 'Booking Valid From',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    booking_to: {
      name: 'Booking Valid to',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    prices: {
      name: 'PP Prices',
      fieldRenderer: CustomFieldForActivityPrices,
      slidePaneFieldRenderer: CustomFieldForActivityPrices,
      fieldType: 'custom',
    },
    commissions: {
      name: 'PP Commissions',
      fieldRenderer: CustomFieldForActivityCommissions,
      slidePaneFieldRenderer: CustomFieldForActivityCommissions,
      fieldType: 'custom',
    },
    group_price: {
      name: 'Group Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    promotion: {
      name: 'Promotion',
      fieldRenderer: SelectField.tableAdapter(promotions),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(promotions),
      switchboard: true,
      url: promotions.client.getAllPath,
      tempSchema: promotions,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/activity-prices'),
};
